import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=ddb44600&"
import script from "./aside.vue?vue&type=script&lang=ts&"
export * from "./aside.vue?vue&type=script&lang=ts&"
import style0 from "./aside.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports